import React from "react";

import { patternsByIds } from "../../constants/patterns";
import { patternCollectionsByIds } from "../../constants/patternCollections";
import { surfacesByIds } from "../../constants/surfaces";
import { surfaceBrandsByIds } from "../../constants/surfaceBrands";

import Button from "../shared/Button";
import Pattern from "../Pattern";
import LocalizedLink from "../../containers/LocalizedLink";

const Composition = props => {
  const pattern = patternsByIds[props.patternId];
  const surface = surfacesByIds[props.surfaceId]
    ? surfacesByIds[props.surfaceId]
    : surfacesByIds[0];

  return (
    <div className="composition">
      <div className="composition__zone">
        <div
          className="composition__img"
          style={{ backgroundImage: `url(${surface.imagePanel})` }}
        />
        <div className="composition__svg">
          <Pattern
            keySeed={props.id}
            config={props.patternConfig}
            pattern={pattern}
            scaled
          />
        </div>
        <div className="composition__actions">
          <div className="composition__actions-button">
            <Button
              onClick={() => props.openShareModelModal(props.id)}
              additionalClassName="button--icon"
              icon="button__icon--share i-share"
            />
          </div>
          <div className="composition__actions-button">
            <Button
              additionalClassName="button--icon"
              onClick={() => {
                props.clearModelExport();
                props.openDownloadFolderModal({
                  userFullname: props.userFullname,
                  userCompany: props.userCompany,
                  folderTitle: props.folderTitle,
                  surfaceId: props.surfaceId,
                  patternId: props.patternId,
                  patternConfig: props.patternConfig,
                  imagePanel: surface.imagePanel
                });
              }}
              icon="button__icon--download i-download"
            />
          </div>

          <div className="composition__actions-button">
            <LocalizedLink className="button button--icon" to={`/models/${props.id}/edit`}>
              <i className="button__icon button__icon--pencil i-pencil" />
            </LocalizedLink>
          </div>
          <div className="composition__actions-button">
            <Button
              onClick={() => props.handleDeleteModel({ id: props.id })}
              additionalClassName="button--icon"
              icon="button__icon--trash i-trash"
            />
          </div>
        </div>
      </div>
      <div className="composition__pattern">
        <div className="font-bold">{pattern["title_"+props.lng]}</div>
        <div>{patternCollectionsByIds[pattern.collectionId]["title_"+props.lng]}</div>
      </div>
      <div className="composition__surface">
        <div className="font-bold">{surface["title_"+props.lng]}</div>
        <div>{surfaceBrandsByIds[surface.brandId].title}</div>
      </div>
    </div>
  );
};

export default Composition;



// WEBPACK FOOTER //
// ./src/components/account/Composition.js